import Bezier from 'bezier-easing';

/** Arrow dimensions. */
export const Arrow = Object.freeze({
  height: 18,
  width: 16
});

/** Easing function. */
export const EasingFn = Bezier(0, 0, 1, 0.5);

/** Origin radius. */
export const OriginRadius = 15;

/** Save Zone fill color. */
export const SafeColor = 'rgba(255, 255, 255, 0.35)';

/** Safe Zone radius. */
export const SafeRadius = 40;

/** Shadow color. */
export const ShadowColor = 'rgba(0, 0, 0, 0.6)';

/** Thresholds. */
export const Threshold = 225;

/** Zoom plus/minus size. */
export const ZoomSize = 12;
